import { mapRoleFromDto } from '@entities/user';
import { mapFirmSummaryFromDto } from '@entities/firm';

import type { ProfileDto } from '../dto';
import type { Profile, PermissionKey } from '../models';

export function mapProfileFromDto(dto: ProfileDto): Profile {
  return {
    id: dto.id,
    firstName: dto.first_name,
    lastName: dto.last_name,
    email: dto.email,
    role: mapRoleFromDto(dto.role),
    firm: dto.firm ? mapFirmSummaryFromDto(dto.firm) : null,
    permissions: Object.fromEntries(
      Object.entries(dto.permissions).map(([key, val]) => [key, val === 'full']),
    ) as Record<PermissionKey, boolean>,
  };
}
